/* ==========================================================================
   「天国への手紙」トップページ用 紹介セクション 専用スクリプト
   ==========================================================================
   ・sections/lumiere-letter-teaser.liquid 専用です。
   ・外部との通信は「公開された手紙を読み込む」1つだけ（fetch / GET）。
     手紙ページ本体と同じ API を読んでいます。
   ・手紙の本文を画面に入れるときは必ず textContent を使います。
     innerHTML は一切使いません（XSS対策）。
   ・手紙が取得できないときは、テーマエディタに入れた「予備の手紙」を
     そのまま表示し続けます。トップページに空白ができないようにするためです。

   表示速度のために気をつけていること（PageSpeed / Core Web Vitals 対策）
   --------------------------------------------------------------------------
   1. 画面に近づくまで通信しません（IntersectionObserver）。
   2. 動くのは画面に入っているあいだだけ。別のタブを見ているとき、
      マウスが乗っているときは止めます（電池とCPUの節約）。
   3. カードの幅は1回だけ測って覚えます。毎回測ると、そのたびに
      ブラウザが画面を計算し直す（レイアウトの巻き戻し）ため遅くなります。
   4. 複製したカードは DocumentFragment にまとめて1回で差し込みます。
   5. 動かしている間に触るのは scrollLeft だけ。幅や位置の読み取りは
      しないので、1コマ（約16ミリ秒）の中で処理が終わります。
   6. 通信量を節約する設定（データセーバー）の方には通信しません。
   ========================================================================== */

(function () {
  'use strict';

  if (window.__lumiereLetterTeaserLoaded) return;
  window.__lumiereLetterTeaserLoaded = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------------
     手紙カードを1枚組み立てる
     L = { to, feeling, body, name, date }
     ---------------------------------------------------------------------- */
  function buildCard(L) {
    var article = document.createElement('article');
    article.className = 'ltht-letter';

    if (L.to) {
      var to = document.createElement('p');
      to.className = 'ltht-letter-to';
      to.textContent = L.to + 'へ';
      article.appendChild(to);
    }

    if (L.feeling) {
      var tag = document.createElement('span');
      tag.className = 'ltht-letter-tag';
      tag.textContent = L.feeling;
      article.appendChild(tag);
    }

    var body = document.createElement('p');
    body.className = 'ltht-letter-body';
    body.textContent = L.body || '';      // ← HTMLとして解釈させない
    article.appendChild(body);

    var meta = document.createElement('div');
    meta.className = 'ltht-letter-meta';
    var name = document.createElement('span');
    name.textContent = L.name ? L.name : '名前のない手紙';
    meta.appendChild(name);
    // 投稿日は表示しません（投稿がまばらで古く見えるため）。APIは L.date を返し続けます
    article.appendChild(meta);

    return article;
  }

  /* ----------------------------------------------------------------------
     スライダー（横スクロール）
     ----------------------------------------------------------------------
     ★ 手紙の数が少なくても必ず流れるようにしています。
       カードが画面の幅に収まってしまうと横へ動かす余地が無くなるため、
       その場合は同じカードを裏で複製して、輪のようにつなげています。
       右端まで来たら、複製ぶんの手前へ音もなく戻すので、
       お客様には途切れずに流れ続けて見えます。

     ★ 動かす速さは自前で作っています。
       ブラウザ標準の「なめらかスクロール」は速さを変えられず、
       一瞬で切り替わってしまうためです。
       動き出しと止まり際をゆっくりにして（イージング）、
       手紙が静かに流れていくように見せています。
     ---------------------------------------------------------------------- */
  function initSlider(slider) {
    var track = slider.querySelector('.ltht-track');
    if (!track) return null;

    var prev = slider.querySelector('.ltht-arrow--prev');
    var next = slider.querySelector('.ltht-arrow--next');

    var intervalMs = (parseFloat(slider.dataset.interval) || 0) * 1000;
    var slideMs = parseInt(slider.dataset.duration, 10) || 1400;

    var timer = null;        // 次の手紙へ送る合図（setInterval）
    var raf = 0;             // 動かしている最中の目印（requestAnimationFrame）
    var paused = false;
    var visible = false;
    var loopWidth = 0;       // 手紙ひとまわりぶんの幅（0 のときは輪にしていない）
    var stepWidth = 0;       // カード1枚ぶんの移動量（幅＋すき間）

    /* ---------- 動かす（イージング付き） ---------- */

    /** ゆっくり動き出して、ゆっくり止まる曲線（ease-in-out） */
    function ease(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animateTo(target) {
      cancelAnimationFrame(raf);

      // 「アニメーションを減らす」設定の方には、動かさず瞬間的に切り替えます
      if (reduceMotion || slideMs <= 0) {
        track.style.scrollSnapType = '';
        track.scrollLeft = target;
        return;
      }

      var from = track.scrollLeft;
      var delta = target - from;
      if (!delta) return;

      // ★ 指でなぞったときの「カードへの吸着」を、動かしている間だけ切ります。
      //   吸着したままだと、途中の位置がそのつど一番近いカードへ
      //   引き戻され、パッと切り替わったように見えてしまいます。
      track.style.scrollSnapType = 'none';

      var startedAt = 0;
      raf = requestAnimationFrame(function frame(now) {
        if (!startedAt) startedAt = now;
        var t = (now - startedAt) / slideMs;
        if (t >= 1) {
          track.scrollLeft = target;       // 最後はぴったり合わせる
          track.style.scrollSnapType = '';  // 吸着を元に戻す
          raf = 0;
          return;
        }
        track.scrollLeft = from + delta * ease(t);
        raf = requestAnimationFrame(frame);
      });
    }

    /* ---------- 輪づくり ---------- */

    /**
     * 元のカードだけでは画面の幅に収まってしまうとき、
     * 足りるまで同じカードを複製して後ろにつなげます。
     * 複製したカードは読み上げソフトには読ませません（同じ文が重なるため）。
     */
    function buildLoop() {
      var clones = track.querySelectorAll('[data-ltht-clone]');
      for (var i = 0; i < clones.length; i++) {
        clones[i].parentNode.removeChild(clones[i]);
      }
      loopWidth = 0;

      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) { stepWidth = track.clientWidth; return; }

      // ★ 幅の測定はここで1回だけ。カードはすべて同じ幅です。
      //   小数点以下まで測ります（offsetWidth は整数に丸められるため、
      //   ひとまわりぶんで数ピクセルずれ、輪に戻る瞬間に見えてしまいます）。
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      stepWidth = originals[0].getBoundingClientRect().width + gap;
      if (stepWidth <= gap) return;

      // 手紙が1通だけのときは輪にしません（同じ手紙が並ぶだけになるため）
      if (originals.length < 2) return;

      var setWidth = originals.length * stepWidth;
      var viewWidth = track.clientWidth;

      // 画面の幅の2倍ぶんが埋まるまで複製します。
      // カードが増えすぎないよう、複製は最大5周・合計40枚までにしています。
      var rounds = Math.ceil((viewWidth * 2) / setWidth);
      if (rounds > 5) rounds = 5;
      if (rounds * originals.length > 40) rounds = Math.floor(40 / originals.length);
      if (rounds < 1) rounds = 1;

      var frag = document.createDocumentFragment();
      for (var r = 0; r < rounds; r++) {
        originals.forEach(function (el) {
          var clone = el.cloneNode(true);
          clone.setAttribute('data-ltht-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          frag.appendChild(clone);
        });
      }
      track.appendChild(frag);   // ★ 差し込みは1回だけ（描き直しを1回に抑える）

      // ひとまわりぶんの幅は、計算ではなく実際の位置の差から求めます。
      // こうすると、戻したときに1ピクセルもずれません。
      var firstClone = track.querySelector('[data-ltht-clone]');
      if (firstClone) {
        loopWidth =
          firstClone.getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
      } else {
        loopWidth = setWidth;
      }
    }

    /* ---------- 送り ---------- */

    function goNext() {
      if (loopWidth) {
        // ひとまわりぶん進んでいたら、見た目が同じ手前の位置へ音もなく戻す
        var at = track.scrollLeft;
        if (at >= loopWidth) { at -= loopWidth; track.scrollLeft = at; }
        animateTo(at + stepWidth);
        return;
      }
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) {
        animateTo(0);             // 輪にできないときは先頭へ戻す
      } else {
        animateTo(track.scrollLeft + stepWidth);
      }
    }

    function goPrev() {
      var at = track.scrollLeft;
      if (loopWidth) {
        // 先頭より手前へ戻るときは、いったん輪の後ろへ回してから動かす
        if (at < stepWidth) { at += loopWidth; track.scrollLeft = at; }
        animateTo(at - stepWidth);
        return;
      }
      if (at <= 8) {
        animateTo(track.scrollWidth);
      } else {
        animateTo(at - stepWidth);
      }
    }

    if (next) next.addEventListener('click', function () { goNext(); restart(); });
    if (prev) prev.addEventListener('click', function () { goPrev(); restart(); });

    /**
     * 指でなぞって動かしたあと、行き過ぎた位置を
     * 見た目が同じ手前の位置へ静かに戻します。
     * 自分で動かしている最中は触りません。
     */
    var idle = null;
    track.addEventListener('scroll', function () {
      if (raf || !loopWidth) return;
      clearTimeout(idle);
      idle = setTimeout(function () {
        if (raf) return;
        if (track.scrollLeft >= loopWidth) {
          track.scrollLeft = track.scrollLeft - loopWidth;
        } else if (track.scrollLeft < 0.5) {
          track.scrollLeft = loopWidth;
        }
      }, 220);
    }, { passive: true });

    /* ---------- 自動送り ----------
       ★ ここで止めるのは「次へ送る合図」だけです。
         動いている最中のカードは最後まで動かします。
         途中で止めると、カードが半端な位置で止まってしまうためです。
       -------------------------------------------------------------- */
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      stop();
      if (intervalMs <= 0) return;                  // 設定で「自動で動かさない」を選んだとき
      if (paused || !visible) return;
      if (track.scrollWidth - track.clientWidth <= 8) return;

      // 動いている時間より送る間隔が短いと、動きが途中で切れてしまいます。
      // 少なくとも「動く時間＋0.4秒」は空けます。
      var wait = Math.max(intervalMs, slideMs + 400);
      timer = setInterval(goNext, wait);
    }
    function restart() { stop(); start(); }

    // マウスが乗っているあいだ／キーボードで触っているあいだは止める
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
      slider.addEventListener(ev, function () { paused = true; stop(); }, { passive: true });
    });
    ['pointerleave', 'focusout', 'touchend', 'touchcancel'].forEach(function (ev) {
      slider.addEventListener(ev, function () { paused = false; start(); }, { passive: true });
    });

    // 別のタブを見ているあいだは止める（無駄に動かさない）
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    // 画面に入っているあいだだけ動かす
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        visible = entries.some(function (en) { return en.isIntersecting; });
        if (visible) { start(); } else { stop(); }
      }, { threshold: 0.15 });
      io.observe(slider);
    } else {
      visible = true;
    }

    /**
     * 輪を組み直して、矢印の要否を見直す。
     * ・手紙を読み込み終えたとき
     * ・画面幅が変わったとき（カードの幅が変わるため）
     */
    function refresh() {
      stop();
      if (raf) { cancelAnimationFrame(raf); raf = 0; }   // 組み直すときだけ動きを止める
      track.scrollLeft = 0;
      buildLoop();
      slider.classList.toggle('is-static', track.scrollWidth - track.clientWidth <= 8);
      start();
    }
    refresh();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 250);
    });

    // 手紙を読み込み終えたあとにもう一度組み直せるよう、外へ渡しておく
    return { refresh: refresh };
  }

  /* ----------------------------------------------------------------------
     手紙の読み込み
     ---------------------------------------------------------------------- */
  function initSection(root) {
    if (root.dataset.lthtReady === '1') return;
    root.dataset.lthtReady = '1';

    var slider = root.querySelector('.ltht-slider');
    if (!slider) return;

    var control = initSlider(slider);
    var track = slider.querySelector('.ltht-track');
    var api = (slider.dataset.api || '').trim();
    var limit = parseInt(slider.dataset.limit, 10) || 6;

    if (!api || !window.fetch) return;   // URL 未設定のときは予備の手紙のまま

    // 通信量を節約する設定の方には通信しません（予備の手紙を表示します）
    var conn = navigator.connection;
    if (conn && conn.saveData) return;

    function load() {
      fetch(api + '/api/letters?limit=' + limit, { priority: 'low' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.ok || !d.letters || d.letters.length === 0) return;

          // 読み込めたときだけ、予備の手紙を本物に差し替えます
          var frag = document.createDocumentFragment();
          d.letters.forEach(function (L) { frag.appendChild(buildCard(L)); });
          track.textContent = '';
          track.appendChild(frag);
          if (control) control.refresh();
        })
        .catch(function () {
          // 取得できないときは予備の手紙をそのまま表示し続けます
          // （エラー文は出しません。世界観を壊さないためです）
        });
    }

    // セクションが画面に近づいてから読み込みます（表示速度への影響を抑えます）
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          load();
        }
      }, { rootMargin: '400px' });
      io.observe(root);
    } else {
      load();
    }
  }

  function boot(scope) {
    var parent = scope || document;
    Array.prototype.forEach.call(
      parent.querySelectorAll('[data-ltht-section]'),
      initSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // テーマエディタで設定を変えた直後にも動くようにします
  document.addEventListener('shopify:section:load', function (ev) {
    boot(ev.target);
  });
})();
